<template lang='pug'>
.review-slide-out(:class='{ "has-review" : asset !== null }')
	asset-slide-out(
		:state='state'
		:asset='asset'
		:asset-key='assetKey'
		:asset-name='assetName'
		@close='$emit( "close" )'
		@edit='$emit( "edit" )'
		@delete='$emit( "delete" )'
	)

		.title-container(
			slot='title'
		)
			h1.title Developer/Utility Review Reference

		page.facilities-page.side-sheet-content(
			slot='side-sheet-content'
			:tabs='tabs'
		)

			.loading-indicator.spacey(
				v-if='dataState === "loading"'
				slot='main-body'
			) Loading
				span .
				span .
				span .

			p.failed.spacey(
				v-else-if='dataState === "failed"'
				slot='main-body'
			) Failed to load Developer/Utility Review

			.body-wrapper(
				v-if='dataState === "loaded"'
				slot='main-body'
			)
				review(
					v-if='asset'
					:review='asset'
				)

			.body(slot='tab-comments' v-if='asset')
				comments(
					:section-id='`reviews-${asset.reviewsKey}`'
					:user='user'
				)

			.body.documents.separate-gradient.down(slot='tab-documents' v-if='asset')
				document-list(
					:documents='asset.folder'
					:a-files='asset.file'
					:assetKey='asset.reviewsKey'
					@close='$emit( "close" )'
				)
</template>

<script>
import AssetSlideOut from '@/components/slide-outs/AssetSlideOut';
import Review from '@/components/slide-outs/reviews/Review';
import SideSheet from '@/components/SideSheet';
import Page from '@/components/Page';
import Comments from '@/components/comments/';
import DocumentList from '@/components/DocumentList/';

import { objectOrNull } from '@/lib/vue-validators';

import { SendEmail } from '@/lib/API';

export default {
	name : 'review-slide-out',

	props : {
		state : {
			type     : String,
			required : true,
		},

		dataState : {
			type     : String,
			required : true,
		},

		asset : {
			required  : true,
			validator : objectOrNull,
		},

		assetKey : {
			required : true,
		},

		assetName : {
			type : String,
		}
	},

	data : () => ( {

		tabs : {
			'comments'  : 'Comments',
			'documents' : 'Documents',
		},

	} ),

	methods : {

		openDocument( document ) {
			this.$store.dispatch( 'openDocument', document.name );
		},

		email( recipientKey, link ) {
			const { request } = this;

			const sectionDescription = `Request #${request.number}`;

			const emailData = {
				sectionDescription,
				link
			};

			SendEmail( this.user.usersKey, [recipientKey], 'reply', emailData );
		},

	},

	computed : {
		user() {
			return this.$store.state.postgresUser;
		}
	},

	components : {
		AssetSlideOut,
		Review,
		SideSheet,
		Page,
		Comments,
		DocumentList,
	}
};
</script>

<style lang='scss'>
.review-slide-out {

	&:not(.has-review) {

		.toggle,
		.main {
			opacity: 0;
		}
	}

	.body-wrapper {
		width: 100%;

		.loading-indicator {
			text-align: center;
		}
	}

	.body {

		.document-list {
			padding: 15px;
		}
	}

	.loading-indicator {
		text-align: center;
	}

	p.failed {
		text-align: center;
	}
}

@media only screen and ( max-width: 640px ) {

	.review-slide-out {

		.copy-url {
			display: none !important;
		}

		.info .list-layout {

			.list-item {
				flex: 0 0 100% !important;
			}
		}

		.body-wrapper {

			.comment-section {

				.comment-count {
					padding: 15px 30px;
				}

				.add-comment .comment-wrapper {
					margin: 15px 30px;
				}
			}

		}
	}
}
</style>
